const asBadge = (status) => {
  const statusLabelOptions = {
    a: "Authorized",
    p: "Paid",
    u: "Not Paid",
    c: "Captured",
    v: "VOID"
  };

  const statusClassOptions = {
    a: "text-info",
    p: "text-success",
    u: "text-warning",
    c: "text-success",
    v: "text-danger"
  };

  const label = statusLabelOptions[status];
  const cssClass = statusClassOptions[status];

  return `<div title="${status}" class="font-weight-bolder text-uppercase ${cssClass}">${label}</div>`;

}

export default {
    asBadge
}